import { render, staticRenderFns } from "./icd.vue?vue&type=template&id=06708680&scoped=true&"
import script from "./icd.vue?vue&type=script&lang=js&"
export * from "./icd.vue?vue&type=script&lang=js&"
import style0 from "./icd.vue?vue&type=style&index=0&id=06708680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06708680",
  null
  
)

export default component.exports